import { ClonableItem } from 'src/app/shared/models/clonable-item';
import IInstanceMonitoringData = ZoningAPI.IInstanceMonitoringData;

export class InstanceMonitoringData extends ClonableItem<IInstanceMonitoringData> implements IInstanceMonitoringData {
    gridicsInstanceId: number;
    unsynchronizedCRGroupIdsCount: number;
}

export function InstanceMonitoringDataFactory(data: IInstanceMonitoringData) {
    return new InstanceMonitoringData(data);
}
